import Primary from './Primary';
import Legacy from './Legacy';

const Config = { Legacy, Primary };

export default Config;
